export default __webpack_public_path__ + "static/media/W-1024-D.e46253d3.png";